export const TWITCH_MIN_STREAM_TIME_MINUTES = 30;
export const deliveryRatioEndpointIds = {
    ADMIN_INCREASE_DELIVERY_RATIO: 'ADMIN_INCREASE_DELIVERY_RATIO',
    GET_DROP_PARTICIPATING_CREATORS: 'GET_DROP_PARTICIPATING_CREATORS',
};
